export const PaymentDetailsMap = {
  CARD: 'cardFingerprint',
  GENERIC_BANK_ACCOUNT: 'accountNumber',
  IBAN: 'IBAN',
  ACH: 'accountNumber',
  SWIFT: 'accountNumber',
  MPESA: 'businessShortCode',
  UPI: 'upiID',
  WALLET: 'walletId',
  CHECK: 'checkNumber',
  CBU: 'CBU',
  CVU: 'CVU',
  ECHECK: 'checkNumber',
  DEBIN: 'authorizationCode',
  QR_CODE: 'qrCode',
  ONLINE_PAYMENT: 'accountNumber',
  WITHDRAWAL_ORDER: 'withdrawalId',
  TED: 'accountNumber',
  BOLETO: 'boletoNumber',
  PIX: 'keyValue',
}
